import React, { useState } from "react";

import { Dialog, FormControl, DialogTitle, DialogContent, DialogActions, Button, withStyles, TextField, Divider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { socket } from "../../../index";
import appTranslations, { detectBrowserLanguageCode, withBrowserLanguageOnTop } from "../../sc-translate/appTranslations";
import * as actions from '../store/profileActions';
import { connect } from 'react-redux';
import { GET_TRANSLATIONS } from "../../../redis-constants";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    formControl: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        width: '90%'
    }
});


const LanguageSelect = props => {
    const { classes, modalState, handleCloseLanguageSelect, onSaveSettings, activeCustomerID, translations, defaultLanguage } = props;
    // Fall back to the browser locale when the user has no language set yet
    // (defaultLanguage='en' is the redux fallback — treat absence the same way).
    const initial = defaultLanguage && defaultLanguage !== 'en'
        ? defaultLanguage
        : (detectBrowserLanguageCode() || defaultLanguage || 'en');
    const [value, setValue] = useState(initial);
    const groupedOptions = withBrowserLanguageOnTop(appTranslations);

    const submitHandler = async _event => {
        if (socket && value) {
            socket.emit(GET_TRANSLATIONS, { LanguageKey: value });
        }
        await onSaveSettings({ DefaultLanguage: value, type: "DefaultLanguage", ActiveCustomerID: activeCustomerID });
        handleCloseLanguageSelect();
    };

    return (
        <Dialog open={modalState}
            onClose={handleCloseLanguageSelect}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}>
            <DialogTitle id="form-dialog-title">{translations["selected_language"] || "Select language"}</DialogTitle>
            <DialogContent>
                <FormControl className={classes.formControl} margin={"dense"}>
                    <Autocomplete
                        options={groupedOptions}
                        groupBy={option => option.__group}
                        getOptionLabel={option => option.displayName || ''}
                        getOptionSelected={(option, val) => option.code === val.code}
                        value={groupedOptions.find(o => o.code === value) || null}
                        onChange={(_event, option) => setValue(option ? option.code : '')}
                        // Mobile/Work-style: no group headers, just a thin divider
                        // between the browser-locale row and the rest.
                        renderGroup={params => [
                            params.group === 'All languages' && (
                                <Divider key={`${params.key}-divider`} component="li" />
                            ),
                            <ul key={params.key} style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                {params.children}
                            </ul>
                        ]}
                        disableClearable
                        blurOnSelect
                        fullWidth
                        renderInput={params => (
                            <TextField
                                {...params}
                                name="language"
                                label={translations['selected_language'] || 'Select language'}
                                margin="dense"
                            />
                        )}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseLanguageSelect} variant="contained" className={classes.buttonSafe}>
                    {translations['cancel'] || 'Cancel'}
                </Button>
                <Button onClick={submitHandler} variant="contained" className={classes.buttonDanger}>
                    {translations['submit'] || 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        defaultLanguage: state?.core?.login?.userSettings?.DefaultLanguage || 'en',
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSaveSettings: params => dispatch(actions.saveSettings(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LanguageSelect));

